__turbopack_context__.v({
  "address": "AddressSummary-module-scss-module__B8TiOW__address",
  "changeButton": "AddressSummary-module-scss-module__B8TiOW__changeButton",
  "name": "AddressSummary-module-scss-module__B8TiOW__name",
  "title": "AddressSummary-module-scss-module__B8TiOW__title",
  "wrapper": "AddressSummary-module-scss-module__B8TiOW__wrapper",
});
